import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { InvoiceSteps } from 'constants/payment';
import { useAppSelector } from 'store/hooks';
import { setStep } from 'store/payment/slice';
import { AmountForm } from 'views/forms/sz/amount-field';
import { CardForm } from 'views/forms/sz/card-form';

import { BaseCardSZ } from '../ui';

const PaymentContainer = () => {
  const { isPayment, paymentData, step } = useAppSelector((state) => state.payment);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isPayment || paymentData?.fix) {
      dispatch(setStep(InvoiceSteps.ENTER_CARD));
    }
  }, [dispatch, isPayment, paymentData]);

  const renderSteps = () => {
    if (step === InvoiceSteps.ENTER_AMOUNT) {
      return <AmountForm />;
    }

    if (step === InvoiceSteps.ENTER_CARD) {
      return <CardForm />;
    }

    return null;
  };

  return <BaseCardSZ>{renderSteps()}</BaseCardSZ>;
};

export { PaymentContainer };
